import { render } from "./two_secondary.vue?vue&type=template&id=0934231a&scoped=true"
import script from "./two_secondary.vue?vue&type=script&lang=js"
export * from "./two_secondary.vue?vue&type=script&lang=js"

import "./two_secondary.vue?vue&type=style&index=0&id=0934231a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0934231a"]])

export default __exports__